import React, { FC, useState } from 'react';

import { Typography } from '@material-ui/core';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import IconButton from '@material-ui/core/IconButton';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import AccountIcon from '../../../../assets/icons/AccountIcon';
import { PROFILE_LINKS } from '../../const';
import useStyles from './styles';

interface UserInfoDropdownProps {
  userName?: string | null;
  teamName?: string | null;
  scrolled: boolean;
  handleOpenUserComWidget: () => void;
  handleLogout: () => void;
}

const UserInfoDropdown: FC<UserInfoDropdownProps> = ({
  userName,
  teamName,
  scrolled,
  handleOpenUserComWidget,
  handleLogout,
}) => {
  const { t } = useTranslation();
  const classes = useStyles(scrolled)();
  const [isDropdownOpen, setDropdownOpen] = useState<boolean>(false);

  const togglDropdown = () => {
    setDropdownOpen((prevState) => !prevState);
  };

  const closeDropdown = () => setDropdownOpen(false);

  const logoutHandler = () => {
    closeDropdown();
    handleLogout();
  };

  const handleClickContact = () => {
    handleOpenUserComWidget();
    closeDropdown();
  };

  return (
    <ClickAwayListener onClickAway={closeDropdown}>
      <div className={classes.dotsBtnWrapper}>
        <IconButton className={classes.dotsBtn} aria-label="dropdown" onClick={togglDropdown}>
          <AccountIcon className={classes.dotsBtnIcon} aria-label="account of current user" />
        </IconButton>
        <div className={cx(classes.dropdown, isDropdownOpen && classes.dropdownOpened)}>
          <div className={classes.dropdownContent}>
            <div className={classes.divider}>
              <Typography className={classes.username}>{userName}</Typography>
              {teamName && <Typography className={classes.team}>{teamName}</Typography>}
            </div>
            <div className={classes.linksWrapper}>
              {PROFILE_LINKS.map((item) => (
                <Link
                  key={item.url}
                  to={item.url}
                  className={classes.dropdownLink}
                  onClick={closeDropdown}
                >
                  {t(item.title)}
                </Link>
              ))}
              {
                // @ts-ignore
                !!window?.userengage && (
                  <div className={classes.dropdownLink} onClick={handleClickContact}>
                    {t('header.contact')}
                  </div>
                )
              }
            </div>
          </div>
          <div className={classes.logout}>
            <button onClick={logoutHandler} className={classes.dropdownLink}>
              {t('header.logout')}
            </button>
          </div>
        </div>
      </div>
    </ClickAwayListener>
  );
};

export default UserInfoDropdown;
